/**
 * @license
 * Copyright (c) 2021-present, FriendliAI Inc. All rights reserved.
 */

import { useTranslation } from 'react-i18next';
import { useNavigate, useParams } from 'react-router-dom';

import Paths from '@fai/friendli-suite/features/routes/paths';
import { usePaymentState } from '@fai/friendli-suite/features/settings/team-settings/use-payment';
import { useTeamRole } from '@fai/friendli-suite/features/settings/team-settings/use-role';
import HeaderMessage from '@fai/friendli-suite/views/layout/header/items/header-message';

function PaymentDeclinedMessage() {
  const { t } = useTranslation();
  const { teamId = '' } = useParams();
  const navigate = useNavigate();

  const handleClickDeclinedPaymentActionButton = () => {
    navigate(Paths.team(teamId).teamSettings.billing);
  };

  return (
    <HeaderMessage
      contentButton={
        <HeaderMessage.ContentActionButton handleOnClick={handleClickDeclinedPaymentActionButton}>
          {t('suite.update_payment_method')}
        </HeaderMessage.ContentActionButton>
      }
      variant="WARNING"
    >
      {t('suite.your_payment_method_was_declined')}
    </HeaderMessage>
  );
}

export default function GlobalHeaderMessage() {
  const { teamId = '' } = useParams();

  const { isTeamOwner, loading: roleLoading } = useTeamRole(teamId);
  const { isPaymentDeclined, loading: paymentLoading } = usePaymentState(teamId);

  if (roleLoading || paymentLoading) return null;

  // If there is an issue with a payment method, show this for team owner.
  if (isTeamOwner && isPaymentDeclined) {
    return <PaymentDeclinedMessage />;
  }

  return null;
}

GlobalHeaderMessage.displayName = 'GlobalHeaderMessage';
